import { useCallback, useEffect, useState } from 'react'
import Chat from './chat'
import Project from './project'

import './styles.css'
import EmptyChat from './chat/emptyChat'
import { getAsanaProjects } from '../../services/api'

const ChatPage = () => {
	const [selected, setSelected] = useState()
	const [projects, setProjects] = useState()
	const [currentPage, setCurrentPage] = useState(0)

	const getProjects = useCallback(async () => {
		getAsanaProjects().then((response) => {
			setProjects(response.data)
		})
	}, [])

	useEffect(() => {
		getProjects()
	}, [])
	return (
		<div id="chatPage">
			<div className="projects-plus-chat">
				<div id="projectsContainer">
					<div className="projectsHeader">
						<span
							className="material-symbols-outlined goback chatGoBack"
							onClick={() => (window.location.href = '/home')}
						>
							arrow_back
						</span>
						<span className="title">Casos</span>
					</div>
					<div className="projectsList">
						{projects ? (
							projects?.map((project, i) => (
								<Project key={i} selected={selected} setSelected={setSelected} project={project} />
							))
						) : (
							<Project empty />
						)}
					</div>
				</div>
				{selected ? (
					<Chat currentPage={currentPage} setCurrentPage={setCurrentPage} selected={selected} />
				) : (
					<EmptyChat />
				)}
			</div>
		</div>
	)
}
export default ChatPage
